import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios'
import ParametersContext, { MainFieldsParamObject } from '../../../../contexts/ParametersContext'
import pencil from '../../../../assets/certificates/Tables/pencil.svg'
import lookup from '../../../../assets/certificates/Tables/lookup.svg'
import SectionContext from '../../../../contexts/SectionContext'
import { useOutletContext } from 'react-router-dom'
import { CertificateOutletType } from '..'
import { GlobalTable, HeaderLine, Td, TdButtons, Th, Tr } from '../../../../components/table-style'

const ParameterTable: React.FC = () => {
  const { setTabIndex } = useOutletContext<CertificateOutletType>()
  const { parameters, setParameters, setStructures, setMainFields, setEditParameterIndex, parametersTableQuantity } = useContext(ParametersContext)  
  const { setCertificatesSection } = useContext(SectionContext)  

  useEffect(() => {
    setTabIndex(1)
  }, [])
  
  useEffect(() => {
    const certificateUrl = process.env.REACT_APP_CERTIFICATES_BASE_URL

    axios 
    .get(`${certificateUrl}/param`, {
      params: {
        quantity: parametersTableQuantity
      }
    })
    .then((response) => {
      // setStock(response.data)
      setParameters(response.data)
    })
    .catch((error) => {
      console.log('Ocorreu um erro ao obter os dados de parâmetros', error)
    })
    .finally(() => {
      console.log("Parameters have been loaded")
    })
  }, [parametersTableQuantity])

  const handleEdit = (index: number) => {
    const selectedStructures = parameters[index].structuresArray
    const selectedMainFields: MainFieldsParamObject = {
      id: parameters[index].id,
      name: parameters[index].name,
      paramClass: parameters[index].paramClass,
      family: parameters[index].family,
      type: parameters[index].type,
      astm: parameters[index].astm,
      uns: parameters[index].uns,
      din: parameters[index].din,
      aisi: parameters[index].aisi,
      others: parameters[index].others,
    }
    setStructures(selectedStructures)
    setMainFields(selectedMainFields)
    setEditParameterIndex(index)
    setCertificatesSection('editParameter')
  }

  const columns = ["Nome", "Subgrupo", "Família", /*"Tipo",*/ "ASTM", "UNS", "DIN", "AISI", "Outras Normas"]

  return (
    <GlobalTable>
      <thead>
        <HeaderLine>
          {columns.map((item, colIndex) => (
            <Th key={item}>{item}</Th>
          ))}
        </HeaderLine>
      </thead>
      <tbody>
      {parameters.slice(0, -1).map((item, rowIndex) => (
        <Tr key={rowIndex}>
            <Td className='notLast'> {item.name} </Td>
            <Td className='notLast'> {item.paramClass} </Td>
            <Td className='notLast'> {item.family} </Td>
            {/* <Td className='notLast'> {item.type} </Td> */}
            <Td className='notLast'> {item.astm} </Td>
            <Td className='notLast'> {item.uns} </Td>
            <Td className='notLast'> {item.din} </Td>
            <Td className='notLast'> {item.aisi} </Td>
            <Td className='notLast'> {item.others} </Td>
            <TdButtons>
              <img 
                onClick={() => handleEdit(rowIndex)} 
                src={pencil} 
                alt='Pencil icon'/> 
            </TdButtons>
        </Tr>
      ))}
      {parameters.length !== 0 &&
        <Tr>
          <Td> {parameters[parameters.length-1].name} </Td>
          <Td> {parameters[parameters.length-1].paramClass} </Td>
          <Td> {parameters[parameters.length-1].family} </Td>
          <Td> {parameters[parameters.length-1].astm} </Td>
          <Td> {parameters[parameters.length-1].uns} </Td>
          <Td> {parameters[parameters.length-1].din} </Td>
          <Td> {parameters[parameters.length-1].aisi} </Td>
          <Td> {parameters[parameters.length-1].others} </Td>
          <Td>
            <img 
              onClick={() => handleEdit(parameters.length-1)} 
              src={pencil} 
              alt='Pencil icon' /> 
          </Td>
        </Tr>
      }
      </tbody>
    </GlobalTable>
  )
}
export default ParameterTable
